export default "__VITE_ASSET__CYRO3z5l__"